/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import QRScanner from 'react-qr-scanner'; // Importar el componente QRScanner
import '../styles/ingreso.css';
import { useAuth } from '../context/AuthContext';

function IngresoPage() {
  const { token } = useAuth();
  const [formattedLocation, setFormattedLocation] = useState('');
  const [isScannerReady, setIsScannerReady] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    setFormattedLocation('Ubicación a escanear'); // Ajusta esto si es necesario

    return () => {
      // Aquí no es necesario detener el escáner, ya que `react-qr-scanner` maneja su propio estado
    };
  }, []);

  const handleScan = (data) => {
    if (data) {
      console.log('Código QR escaneado:', data.text);

      // Detener el escáner después de escanear
      setIsScannerReady(false);

      // Navegar a la nueva página después de escanear
      navigate(`/storage/ingreso/${data.text.trim()}`);
    }
  };

  const handleError = (error) => {
    console.error('Error al escanear:', error);
  };

  return (
<div className="qrscanner-container">
  <button onClick={() => navigate('/storage')} className="qrscanner-back-button">
    &#8592;
  </button>

  <h3 className="qrscanner-title">Escanea ubicación donde ingresará</h3>

  <div className="qrscanner-video-container">
    {isScannerReady ? (
      <QRScanner
        delay={300} // La frecuencia de escaneo en milisegundos
        onScan={handleScan}
        onError={handleError}
        style={{ width: '100%', height: '100%' }} // Ajusta el estilo de la cámara
        constraints={{
          video: {
            facingMode: 'environment', // Force back camera
          },
        }}
      />
    ) : (
      <div className="loading-container">
      <div className="spinner"></div>
    </div>
    )}
  </div>
</div>

  );
}

export default IngresoPage;
